import React from 'react';
import PropTypes from 'prop-types';

const Arrow = ({ direction = 'up' }) => {
  switch (direction) {
    case 'up':
      return (
        <svg
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M4.43999 0.515238L1.15839 3.79684C0.855975 4.09926 0.855975 4.60324 1.15839 4.90566C1.46081 5.20808 1.96479 5.20808 2.26721 4.90566L4.21598 2.968V10.136C4.21598 10.5728 4.56315 10.92 4.99995 10.92C5.43675 10.92 5.78393 10.5728 5.78393 10.136V2.968L7.72151 4.90558C8.02393 5.208 8.52792 5.208 8.83034 4.90558C8.98713 4.74878 9.06557 4.54714 9.06557 4.34558C9.06557 4.14402 8.98714 3.94238 8.83034 3.78558L5.55994 0.515178C5.41431 0.369554 5.21276 0.279938 4.99994 0.279938C4.78711 0.279938 4.58555 0.358376 4.43993 0.515178L4.43999 0.515238Z"
            fill="var(--SUCCESS_STATUS)"
          />
        </svg>
      );
    case 'down':
      return (
        <svg
          width="10"
          height="11"
          viewBox="0 0 10 11"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.56001 10.4848L8.84161 7.20316C9.14403 6.90074 9.14403 6.39676 8.84161 6.09434C8.53919 5.79192 8.03521 5.79192 7.73279 6.09434L5.78402 8.032L5.78402 0.864002C5.78402 0.427202 5.43685 0.0800209 5.00005 0.0800209C4.56325 0.0800209 4.21607 0.427202 4.21607 0.864002L4.21607 8.032L2.27849 6.09442C1.97607 5.792 1.47208 5.792 1.16966 6.09442C1.01287 6.25122 0.934425 6.45286 0.934425 6.65442C0.934425 6.85598 1.01286 7.05762 1.16966 7.21442L4.44006 10.4848C4.58569 10.6304 4.78724 10.7201 5.00006 10.7201C5.21289 10.7201 5.41445 10.6416 5.56007 10.4848L5.56001 10.4848Z"
            fill="var(--DANGER)"
          />
        </svg>
      );
    default:
      return null;
  }
};

Arrow.propTypes = {
  direction: PropTypes.string,
};

export default Arrow;
